import { useSelector } from "react-redux";

import { ConfirmationFormInjected } from "./ConfirmationForm";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { IStore, Step } from "../../../DataTypes/storeTypes";

function GetStripeData() {
    const { stripeKey, defaultStripeAccount, selectedPractitionerId, availablePractitioners } = useSelector(
        (state: IStore) => ({
            stripeKey: state.initialSettings.accountInitialSettings.organisationInfo.stripePublishableKey,
            defaultStripeAccount: state.initialSettings.accountInitialSettings.organisationInfo.stripeAccount,
            selectedPractitionerId: state.stepsInfo[Step.Provider]?.id,
            availablePractitioners: state.providers,
        })
    );

    let stripeAccountToUse = defaultStripeAccount;

    const selectedProvider = availablePractitioners.find((x) => x.id == selectedPractitionerId);
    if (selectedProvider?.stripeAccount != null) {
        stripeAccountToUse = selectedProvider.stripeAccount;
    }

    return { stripeKey, stripeAccount: stripeAccountToUse };
}

let stripePromise: Promise<Stripe> | null = null;
let stripeAccount: string | null = null;

export default function ConfirmationStep() {
    const { stripeKey, stripeAccount: newStripeAccount } = GetStripeData();

    // only load Stripe once
    if (newStripeAccount !== stripeAccount) {
        stripeAccount = newStripeAccount;
        stripePromise = loadStripe(stripeKey, { stripeAccount });
    }

    return (
        <Elements stripe={stripePromise}>
            <ElementsConsumer>
                {({ stripe, elements }) => <ConfirmationFormInjected stripe={stripe} elements={elements} />}
            </ElementsConsumer>
        </Elements>
    );
}
